import { AfterViewInit, Component, ElementRef, EventEmitter, Input, OnInit, Output, QueryList, ViewChildren } from '@angular/core';

import { TwcListItemComponent } from '@topcon/twc-angular';

export interface IconActionPermissionList {
    id: string;
    icon: string;
    status: PermissionListIconStatus;
    tooltip?: string;
    isDisabled?: boolean;
}

export type PermissionListIconStatus = 'active' | 'inactive' | 'forced' | 'deny-forced';

export interface PermissionListItem {
    id: string;
    name: string;
    iconsAction: IconActionPermissionList[];
}

export interface ActionPermissionList {
    idItem: string;
    iconAction: IconActionPermissionList;
}

export type PermissionListIconType = 'switch' | 'button';

/** This component displays the permissions list used in permissions editor. An event will be emitted when an action is clicked. */
@Component({
    selector: 'cw-permissions-list',
    templateUrl: './permissions-list.component.html',
    styleUrls: ['./permissions-list.component.scss'],
    standalone: false,
})
export class PermissionsListComponent implements OnInit, AfterViewInit {
    /** List of item to be displayed in the component */
    @Input() list: PermissionListItem[] = [];

    /** If this property is true, any action can't be executed*/
    @Input() isReadOnly = false;

    /** Initial selection */
    @Input() initialSelection: string | null = null;

    /** If isSelectionEnabled is false the component doesn't display the selected row (default true)*/
    @Input() isSelectionEnabled = true;

    @Input() iconsType: PermissionListIconType = 'switch';

    /** It will be emitted when clicking in an icon action */
    @Output() actionClick = new EventEmitter<ActionPermissionList>();

    /** It will be emitted when selecting an item */
    @Output() selectItem = new EventEmitter<string>();

    @ViewChildren(TwcListItemComponent, { read: ElementRef }) listItems!: QueryList<ElementRef>;

    selectedItem = '';

    ngOnInit(): void {
        if (this.initialSelection) {
            this.selectedItem = this.initialSelection;
        }
    }

    ngAfterViewInit(): void {
        if (this.initialSelection) {
            setTimeout(() => {
                this.scrollToChild(this.selectedItem);
            }, 0);
        }
    }

    onActionClick(idItem: string, iconAction: IconActionPermissionList): void {
        if (iconAction.isDisabled || this.isReadOnly) {
            return;
        }
        this.actionClick.emit({ idItem, iconAction });
    }

    onSelect(id: string): void {
        this.selectedItem = id;
        this.selectItem.emit(id);
    }

    private scrollToChild(id: string): void {
        const listItems = this.listItems.toArray();
        const index = this.list.findIndex((item) => item.id === id);

        if (listItems[index]) {
            listItems[index].nativeElement.scrollIntoView({ behavior: 'instant', block: 'start' });
        }
    }
}
